import { render, staticRenderFns } from "./embryoDetails.vue?vue&type=template&id=8f58d1b4&scoped=true"
import script from "./embryoDetails.vue?vue&type=script&lang=js"
export * from "./embryoDetails.vue?vue&type=script&lang=js"
import style0 from "./embryoDetails.vue?vue&type=style&index=0&id=8f58d1b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f58d1b4",
  null
  
)

export default component.exports